import { render, staticRenderFns } from "./issue_card_time_info.vue?vue&type=template&id=16a9f1d6"
import script from "./issue_card_time_info.vue?vue&type=script&lang=js"
export * from "./issue_card_time_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports